var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFileTypesLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 46,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#file-types-link_svg__a)",
  d: "M32.25 1.5H3.75C1.679 1.5 0 3.198 0 5.293v36.414C0 43.802 1.679 45.5 3.75 45.5h28.5c2.071 0 3.75-1.698 3.75-3.793V5.293C36 3.198 34.321 1.5 32.25 1.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.3,
  d: "M32.25 1.5H3.75C1.679 1.5 0 3.198 0 5.293v36.414C0 43.802 1.679 45.5 3.75 45.5h28.5c2.071 0 3.75-1.698 3.75-3.793V5.293C36 3.198 34.321 1.5 32.25 1.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#file-types-link_svg__b)",
  d: "M32.25 0H3.75C1.679 0 0 1.698 0 3.793v36.414C0 42.302 1.679 44 3.75 44h28.5c2.071 0 3.75-1.698 3.75-3.793V3.793C36 1.698 34.321 0 32.25 0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M32.25 0H3.75C1.679 0 0 1.698 0 3.793v36.414C0 42.302 1.679 44 3.75 44h28.5c2.071 0 3.75-1.698 3.75-3.793V3.793C36 1.698 34.321 0 32.25 0Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.258 17.656c1.914-1.953 5.078-1.953 7.031 0 1.875 1.836 1.953 4.805.273 6.797l-.234.235c-.234.273-.625.312-.86.078a.628.628 0 0 1-.077-.899l.195-.234c1.289-1.485 1.21-3.711-.156-5.078a3.725 3.725 0 0 0-5.313 0l-4.844 4.843a3.725 3.725 0 0 0 0 5.313c1.446 1.445 3.829 1.445 5.274 0l.898-.898c.235-.235.625-.235.899 0a.662.662 0 0 1 0 .898l-.899.86a4.998 4.998 0 0 1-7.07 0 4.998 4.998 0 0 1 0-7.071l4.883-4.844Zm11.445 9.727c-1.914 1.953-5.078 1.953-7.031 0-1.875-1.836-1.953-4.805-.274-6.797l.235-.234c.234-.274.625-.313.86-.079a.628.628 0 0 1 .077.899l-.195.234c-1.29 1.485-1.21 3.711.156 5.078a3.726 3.726 0 0 0 5.313 0l4.843-4.843a3.725 3.725 0 0 0 0-5.313c-1.445-1.445-3.828-1.445-5.273 0l-.898.899c-.235.234-.625.234-.899 0-.234-.274-.234-.665 0-.899l.899-.898a4.998 4.998 0 0 1 7.07 0 4.998 4.998 0 0 1 0 7.07l-4.883 4.883Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "file-types-link_svg__a",
  x1: 3,
  x2: 33,
  y1: 6.5,
  y2: 46.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A94F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.393,
  stopColor: "#49A3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EF38F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "file-types-link_svg__b",
  x1: 3,
  x2: 33,
  y1: 5,
  y2: 45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A94F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.393,
  stopColor: "#49A3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EF38F"
})))));
export { SvgFileTypesLink as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDM1MDk2NGM0YmJjNGZkMDUwNzdlOWI3ODljMTA4YmUuc3ZnIjs=";